export default __webpack_public_path__ + "static/media/homeowners-home-carousel.29d38f01.jpg";